import { BaSeHeading5, BaSeParagraph, BaSeTheme } from '@base/react';
import React, { useContext } from 'react';
import Button from '../../components/button';
import { OptionJohari } from './components/Option-johari';
import { StepContext } from './context/StepContext';
import { useStep } from './hook/useStep';
import { AlignButton, Container, Content, Header } from './johari-styled';

export const Adjetivos = ({ dataStep, settings }) => {
  const { save } = useStep();
  const [qtdSelected, setQtdSelected] = React.useState(0);
  const { setCurrentStep } = useContext(StepContext);

  return (
    <Container>
      <Header>
        <BaSeHeading5
          isBold
          color={BaSeTheme.colors.institucionais.cinzaSebrae97}
        >
          Características marcantes?
        </BaSeHeading5>

        <BaSeHeading5 color={BaSeTheme.colors.institucionais.cinzaSebrae75}>
          Feedback.
        </BaSeHeading5>
      </Header>
      <div style={{ gap: 8 }}>
        <Content>
          {dataStep?.questions.map((domain) => (
            <OptionJohari
              domain={domain}
              nome={dataStep?.name}
              setQtdSelected={setQtdSelected}
            />
          ))}
        </Content>
        <BaSeParagraph
          color={BaSeTheme.colors.institucionais.cinzaSebrae97}
        >{`Adjetivos marcados: ${qtdSelected}`}</BaSeParagraph>
      </div>
      <AlignButton>
        <Button
          calback={() => setCurrentStep((prev) => prev - 1)}
          value={'VOLTAR'}
          valueSmall={'VOLTAR'}
          withBorder={true}
          color={settings?.tertiaryColor}
          borderColor={settings?.primaryColor}
        />
        <Button
          calback={save}
          value={'SALVAR'}
          valueSmall={'SALVAR'}
          withBorder={true}
          color={settings?.tertiaryColor}
          borderColor={settings?.primaryColor}
        />
      </AlignButton>
    </Container>
  );
};
